module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('h1', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "pagevi"
    }
  }), _c('a', {
    attrs: {
      "id": "pagevii"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/cvi.htm"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "also"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/also.htm"
    }
  }, [_vm._v("Also by Mark Bowden")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "tp"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/tp.htm"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "cop"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/cop.htm"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ded"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ded.htm"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "pro"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/pro.htm"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "p01"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p01.htm"
    }
  }, [_vm._v("The Rise of "), _c('em', [_vm._v("El Doctor")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p01_c01"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p01_c01.htm#p01_c01"
    }
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p01_c02"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p01_c02.htm#p01_c02"
    }
  }, [_vm._v("Chapter Two")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p01_c03"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p01_c03.htm#p01_c03"
    }
  }, [_vm._v("Chapter Three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p01_c04"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p01_c04.htm#p01_c04"
    }
  }, [_vm._v("Chapter Four")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p01_c05"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p01_c05.htm#p01_c05"
    }
  }, [_vm._v("Chapter Five")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "p02"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p02.htm"
    }
  }, [_vm._v("The First War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p02_c01"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p02_c01.htm#p02_c01"
    }
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p02_c02"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p02_c02.htm#p02_c02"
    }
  }, [_vm._v("Chapter Two")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p02_c03"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p02_c03.htm#p02_c03"
    }
  }, [_vm._v("Chapter Three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p02_c04"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p02_c04.htm#p02_c04"
    }
  }, [_vm._v("Chapter Four")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p02_c05"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p02_c05.htm#p02_c05"
    }
  }, [_vm._v("Chapter Five")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "p03"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p03.htm"
    }
  }, [_vm._v("Imprisonment and Escape")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p03_c01"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p03_c01.htm#p03_c01"
    }
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p03_c02"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p03_c02.htm#p03_c02"
    }
  }, [_vm._v("Chapter Two")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p03_c03"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p03_c03.htm#p03_c03"
    }
  }, [_vm._v("Chapter Three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p03_c04"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p03_c04.htm#p03_c04"
    }
  }, [_vm._v("Chapter Four")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p03_c05"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p03_c05.htm#p03_c05"
    }
  }, [_vm._v("Chapter Five")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p03_c06"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p03_c06.htm#p03_c06"
    }
  }, [_vm._v("Chapter Six")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p03_c07"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p03_c07.htm#p03_c07"
    }
  }, [_vm._v("Chapter Seven")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p03_c08"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p03_c08.htm#p03_c08"
    }
  }, [_vm._v("Chapter Eight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p03_c09"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p03_c09.htm#p03_c09"
    }
  }, [_vm._v("Chapter Nine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p03_c10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p03_c10.htm#p03_c10"
    }
  }, [_vm._v("Chapter Ten")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p03_c11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p03_c11.htm#p03_c11"
    }
  }, [_vm._v("Chapter Eleven")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "p04"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p04.htm"
    }
  }, [_c('em', [_vm._v("Los Pepes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p04_c01"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p04_c01.htm#p04_c01"
    }
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p04_c02"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p04_c02.htm#p04_c02"
    }
  }, [_vm._v("Chapter Two")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p04_c03"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p04_c03.htm#p04_c03"
    }
  }, [_vm._v("Chapter Three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "p05"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p05.htm"
    }
  }, [_vm._v("The Kill")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p05_c01"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p05_c01.htm#p05_c01"
    }
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p05_c02"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p05_c02.htm#p05_c02"
    }
  }, [_vm._v("Chapter Two")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p05_c03"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p05_c03.htm#p05_c03"
    }
  }, [_vm._v("Chapter Three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p05_c04"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p05_c04.htm#p05_c04"
    }
  }, [_vm._v("Chapter Four")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p05_c05"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p05_c05.htm#p05_c05"
    }
  }, [_vm._v("Chapter Five")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p05_c06"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p05_c06.htm#p05_c06"
    }
  }, [_vm._v("Chapter Six")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p05_c07"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p05_c07.htm#p05_c07"
    }
  }, [_vm._v("Chapter Seven")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "p06"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p06.htm"
    }
  }, [_vm._v("Aftermath")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "sources"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/sources.htm"
    }
  }, [_vm._v("Sources")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ack.htm"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "index"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/index.htm"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/back.htm"
    }
  }, [_vm._v("Back Cover")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33ef1ee3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/toc.vue
// module id = 75
// module chunks = 0